/**
 * @author [tuqiushuang]
 * @email [tuqiushuang@xuetangx.com]
 * @create date 2022-01-05 10:57:25
 * @modify date 2022-01-05 10:57:25
 * @desc [埋点上报]
 */

import axios from 'axios'

function getUUID() {
  let _uuid = null
  if(window.localStorage) {
    _uuid = window.localStorage.getItem('_uuid')
  }

  if(!_uuid) {
    _uuid = 'xxxxxyxxxxxyxx4xxxyxxxxxyxxxxxyxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
      return v.toString(16);
    });

    try {
      window.localStorage.setItem('_uuid', _uuid)
    } catch(error) {
    }
  }

  return _uuid;
}


let sensorsDataReprot = {
  options: {
    // 上报数据结构
    log: {
      // 平台 1：学堂 2：雨课堂 3：学堂云 ...
      platform: 2,
      terminal_type: (function() {
        var sUserAgent = navigator.userAgent.toLowerCase();
        if(sUserAgent && /flutterapp/i.test(sUserAgent)){
          return 'app-h5'
        }else if(window.__wxjs_environment && window.__wxjs_environment === 'miniprogram'){
          return 'minimp-h5'
        }else if(sUserAgent && /MicroMessenger/i.test(sUserAgent)){
          return 'gzh-h5'
        }else if(sUserAgent && /(ipad|iphone os|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile|webview)/i.test(sUserAgent)){
          return 'h5'
        }
        return "web"
      })(),
      app_name: 'ykt',
      time: (new Date()).getTime(),
      language: 'zh_CN',
      // 原始ID 默认UUID
      original_id: getUUID(),
      // 用户ID
      distinct_id: '',
      environment: (function(){
        let hostname = window.location.hostname;
        if(/^(www\.xuetangx\.com|next\.xuetangx\.com|www\.yuketang\.cn)$/.test(hostname)){
          return 'rain'
        }else if(/^(pre-apple-www\.xuetangonline\.com|pre-apple-ykt\.xuetangonline\.com)$/.test(hostname)){
          return 'wind'
        }else if(/^(huanghe\.yuketang\.cn)$/.test(hostname)){
          return 'huanghe'
        }else if(/^(pro\.yuketang\.cn|yuketang\.tsinghua.edu\.cn)$/.test(hostname)){
          return 'thu'
        }else if(/^(changjiang\.yuketang\.cn)$/.test(hostname)){
          return 'changjiang'
        }else if(/^(rain\.xuetangonline.com|gdufe\.xuetangonline\.com)$/.test(hostname)){
          return 'gc'
        }else{
          return 'thunder'
        }
      })(),
      app_version: 'v2.0',
    }
  },

  /**
   * @method 用户ID读取
   * @params
   */
   getUserId(data) {
    try {
      let uid = data && data.userId || window.userId;
      if(!uid) {
        // 各项目需要根据项目store取
        // 新web
        if(window.localStorage && window.localStorage.vuex) {
          let store = JSON.parse(window.localStorage.vuex);
          if(store && store.userInfo && store.userInfo.user_id) {
            uid = store.userInfo.user_id;
          }
        }

        // 新版h5
        if(window.localStorage && window.localStorage['new-mobile-vuex']) {
          let store = JSON.parse(window.localStorage['new-mobile-vuex']);
          if(store && store.user && store.user.id) {
            uid = store.user.id;
          }
        }
      }

      return uid;
    } catch(error) {
      return null;
    }
  },

  /**
   * @method 直播打点
   * @params
   */
   initLog(data) {
    let log = this.options.log;

    try {

      let uid = this.getUserId(data) || log.original_id;
      let presetProperties = sensors.getPresetProperties();
      if(uid) {
        delete presetProperties._distinct_id
        presetProperties.distinct_id = uid
      }else {
        presetProperties.distinct_id = presetProperties._distinct_id
        delete presetProperties._distinct_id
      }

      log = Object.assign({}, log, data, presetProperties, {
        time: (new Date()).getTime(),
        is_register: this.getUserId() ? true : false,
      });

      return log;
    } catch(error) {
      console.error('[initLog] exception:%s', error.message);

      return log;
    }
  },

  /**
   * @method 上报
   * @params
   */
   reportLog(data) {
    let URL = '/video-log/log/track/';

    if(!window.sensors) return

    let log = this.initLog(data);
    if(!log) {
      log = this.options.log;
    }

    const params = {
      'uip': '',
      'data': log,
      'ts_ms': (new Date()).getTime()
    };

    axios.post(URL, params);
  },
}

export default sensorsDataReprot;



// WEBPACK FOOTER //
// ./src/util/sensors-report.js